import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    width: 204,
    maxHeight: 309,
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[1],
    border: `1px solid ${theme.palette.neutral.lightest}`,
    '&:focus-within, &:hover': {
      borderColor: theme.palette.primary.main,
      '& svg path': {
        color: theme.palette.primary.main,
      },
    },
  },

  container: {
    paddingBlock: theme.spacing(2),
    backgroundColor: theme.palette.neutral.lightest,
    width: '100%',
    alignItems: 'flex-start',
    borderRadius: theme.spacing(1, 1, 0, 0),
    margin: theme.spacing(0),
  },

  imageContainer: {
    backgroundColor: theme.palette.neutral.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.spacing(0, 0, 1, 1),
    height: 234,
    '& img': {
      maxHeight: 180,
    },
  },
}))

export default useStyles
